import React, { useState } from "react";
import { Row, Card } from 'antd'; 
import { compose, graphql, ApolloConsumer } from 'react-apollo';
import { addBranchM, updateBranchM } from '../../../graphql/mutation/branch';
import { getBranch } from '../../../graphql/query/branch';
import AntSpin from "../../common/AntSpin";
import SimpleInput from "../../common/SimpleInput";
import { handleInput } from "./handleInput";
import { validForm } from "../../../functions/validForm";
import { openNotificationWithIcon } from "../../common/Notification";
import SideButton from "../../common/SideButton";

function BranchForm({props, addBranch, updateBranch}){
    let [ branch, setBranch ] = useState({
        _id: "",
        name: undefined
    });
    let [ loading, setLoading ] = useState(false);

    function update(){
        let body = {
            branch,
            updateBranch
        };

        props.UPDATE_BRANCH(body);
        openNotificationWithIcon('success', "Sucesso", "Filial atualizada com sucesso", "", 7);
        setBranch(branch = {...branch,
            _id: "",
            name: undefined
        })
    }

    function add(){
        let body = {
            branch,
            addBranch
        };
        
        props.ADD_BRANCH(body);
        openNotificationWithIcon('success', "Sucesso", "Filial adicionado com sucesso", "", 7);

        setBranch(branch = {...branch,
            _id: "",
            name: undefined
        })
    }

    function handleOk(){
        if(!validForm(branch)){
            openNotificationWithIcon('warning', "Aviso", "Há informações incompletas no formulario.", "", 5);
            return 
        }
        
        if(branch._id === "") add()
        else update()   
    }

    async function getBranchDB(connection){
        if(localStorage.getItem('@Ossel:UpdateID')){
            setLoading(loading = true);

            const { data } = await connection.query({
                query: getBranch,
                variables: { _id: localStorage.getItem('@Ossel:UpdateID') }
            }); 
            
            setBranch(branch = {...branch,
                _id: data.branch._id,
                name: data.branch.name
            });
          
            localStorage.removeItem('@Ossel:UpdateID');
            setLoading(loading = false);
        }

        return null
    }

    function renderBody(connection){
        getBranchDB(connection);

        if(!loading) return(
            <Row>
                <Card
                    title="Cadastro"
                    style={{ width: "95%", marginTop: 25, marginLeft: "auto", marginRight: "auto" }}
                >

                    <SimpleInput
                        data={branch} 
                        setData={setBranch} 
                        handleInput={handleInput} 
                        label={"Nome Filial"}
                        inputName={"name"}
                        placeholder={"Ex: Vila Santa Rita"}
                        required={true}
                    />

                    <SideButton
                        clickAction={handleOk}
                    />
                </Card>
            </Row>
        )
        else return <AntSpin marginTop={"20%"}/>
    }

    return (
        <ApolloConsumer>
            {client => renderBody(client)}
        </ApolloConsumer>
    );
}

export default compose(
    graphql( addBranchM, { name: "addBranch" } ),
    graphql( updateBranchM, { name: "updateBranch" } ),
)(BranchForm); 


// WEBPACK FOOTER //
// ./src/components/general/branchFormWrapper/BranchForm.jsx